import { render, staticRenderFns } from "./CampaignModal.vue?vue&type=template&id=d63414a4"
import script from "./CampaignModal.vue?vue&type=script&lang=ts"
export * from "./CampaignModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports